import api from '../../../../api/client';

export const ACCOUNT_HEAD_OPTIONS = [
  { value: '', label: '-- Select Account Head --' },
  { value: 'Basic Salary Expense', label: 'Basic Salary Expense' },
  { value: 'Dearness Allowance Expense', label: 'Dearness Allowance Expense' },
  { value: 'Conveyance Expense', label: 'Conveyance Expense' },
  { value: 'House Rent Allowance Expense', label: 'House Rent Allowance Expense' },
  { value: 'Medical Allowance Expense', label: 'Medical Allowance Expense' },
  { value: 'Special Allowance Expense', label: 'Special Allowance Expense' },
  { value: 'Professional Tax Payable', label: 'Professional Tax Payable' },
  { value: 'Provident Fund Payable', label: 'Provident Fund Payable' },
  { value: 'ESIC Payable', label: 'ESIC Payable' },
  { value: 'Salary & Wages General', label: 'Salary & Wages General' },
];

export const PAY_HEAD_TYPE_OPTIONS = [
  { value: 'Earning', label: 'Earning' },
  { value: 'Deduction', label: 'Deduction' },
];

export const CATEGORY_OPTIONS = [
  { value: 'Select', label: 'Select' },
  { value: 'Bonus', label: 'Bonus' },
  { value: 'Income Tax', label: 'Income Tax' },
  { value: 'Professional Tax', label: 'Professional Tax' },
  { value: 'PF - Employer', label: 'PF - Employer' },
  { value: 'PF - Employee', label: 'PF - Employee' },
  { value: 'PF - Voluntary', label: 'PF - Voluntary' },
  { value: 'ESIC - Employer', label: 'ESIC - Employer' },
  { value: 'ESIC - Employee', label: 'ESIC - Employee' },
  { value: 'NPS (Tier I) - Employer', label: 'NPS (Tier I) - Employer' },
  { value: 'NPS (Tier I) - Employee', label: 'NPS (Tier I) - Employee' },
  { value: 'NPS (Tier II) - Employee', label: 'NPS (Tier II) - Employee' },
  { value: 'EPS - Employer', label: 'EPS - Employer' },
  { value: 'EPS - Employee', label: 'EPS - Employee' },
  { value: 'EDLI Contribution', label: 'EDLI Contribution' },
  { value: 'EDLI Admin Charges', label: 'EDLI Admin Charges' },
  { value: 'Employee State Insurance', label: 'Employee State Insurance' },
  { value: 'PF Admin Charges', label: 'PF Admin Charges' },
];

export const INCOME_TYPE_OPTIONS = [
  { value: 'Fixed', label: 'Fixed' },
  { value: 'Variable', label: 'Variable' },
];

export const CALCULATION_TYPE_OPTIONS = [
  { value: 'As Computed Value', label: 'As Computed Value' },
  { value: 'Flat Rate', label: 'Flat Rate' },
  { value: 'On Attendance', label: 'On Attendance' },
];

export const ATTENDANCE_LEAVE_WITH_PAY_OPTIONS = [
  { value: 'Not Applicable', label: 'Not Applicable' },
  { value: 'Present', label: 'Present' },
  { value: 'Absent', label: 'Absent' },
];

export const CALCULATION_PERIOD_TYPE_OPTIONS = [
  { value: 'Months', label: 'Months' },
  { value: 'Weeks', label: 'Weeks' },
  { value: 'Days', label: 'Days' },
];

export const BASIS_OF_CALC_PER_DAY_OPTIONS = [
  { value: 'As Per Calendar Period', label: 'As Per Calendar Period' },
  { value: 'User Defined', label: 'User Defined' },
];

export const YES_NO_OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const SLAB_TYPE_OPTIONS = [
  { value: 1, label: 'Percentage (%)' },
  { value: 2, label: 'Fixed Value (₹)' },
];

export const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Archive', label: 'Archived' },
  { value: 'All', label: 'All' },
];

const CATEGORY_MAP = {
  Select: 0,
  Bonus: 1,
  'Income Tax': 2,
  'Professional Tax': 3,
  'PF - Employer': 4,
  'PF - Employee': 5,
  'PF - Voluntary': 6,
  'ESIC - Employer': 7,
  'ESIC - Employee': 8,
  'NPS (Tier I) - Employer': 9,
  'NPS (Tier I) - Employee': 10,
  'NPS (Tier II) - Employee': 11,
  'EPS - Employer': 12,
  'EPS - Employee': 13,
  'EDLI Contribution': 14,
  'EDLI Admin Charges': 15,
  'Employee State Insurance': 16,
  'PF Admin Charges': 17,
};

const CATEGORY_ID_TO_NAME = {
  0: 'Select',
  1: 'Bonus',
  2: 'Income Tax',
  3: 'Professional Tax',
  4: 'PF - Employer',
  5: 'PF - Employee',
  6: 'PF - Voluntary',
  7: 'ESIC - Employer',
  8: 'ESIC - Employee',
  9: 'NPS (Tier I) - Employer',
  10: 'NPS (Tier I) - Employee',
  11: 'NPS (Tier II) - Employee',
  12: 'EPS - Employer',
  13: 'EPS - Employee',
  14: 'EDLI Contribution',
  15: 'EDLI Admin Charges',
  16: 'Employee State Insurance',
  17: 'PF Admin Charges',
};

export function mapBackendToFrontend(item) {
  if (!item) return null;
  const isEarning = (item.pay_head_type || 'E').toUpperCase() === 'E';

  // Map calculation type code to label
  let calcType = 'On Attendance';
  if (item.calculation_type === 'C') calcType = 'As Computed Value';
  else if (item.calculation_type === 'F' || item.calculation_type === 'P') calcType = 'Flat Rate';
  else if (item.calculation_type === 'U') calcType = 'User Defined';

  const catName = CATEGORY_ID_TO_NAME[item.category_id] || 'Select';

  return {
    id: item.id,
    name: item.name || '',
    alias: item.alias || '',
    accountHead: item.alias || '',
    acHeadId: item.ac_head_id || 0,
    payslipDesc: item.pay_slip_desc || item.name || '',
    payHeadType: isEarning ? 'Earning' : 'Deduction',
    category: catName,
    incomeType: (item.income_type || 'F').toUpperCase() === 'V' ? 'Variable' : 'Fixed',
    calculationType: calcType,
    attendanceLeaveWithPay: item.attendance_leave_with_pay || 'Not Applicable',
    calculationPeriodType: (item.calculation_period || 'M').toUpperCase() === 'D' ? 'Days' : 'Months',
    basisOfCalcPerDay: item.basis_of_calculation_per_day || 'As Per Calendar Period',
    userDefinedDays: item.user_defined_days || 0,
    includeInSalarySlip: item.include_in_sal_slip ? 'Yes' : 'No',
    effectNetSalary: item.effect_net_sal ? 'Yes' : 'No',
    percentage: Number(item.percentage || 0),
    value: Number(item.value || 0),
    archive: Boolean(item.archive),
    status: item.archive ? 'Archive' : 'Active',
    formulaCount: Number(item.formula_count || (item.formulas ? item.formulas.length : 0)),
    slabCount: Number(item.slab_count || (item.slabs ? item.slabs.length : 0)),
    formulas: Array.isArray(item.formulas)
      ? item.formulas.map((f) => ({
          id: f.id,
          payheads_id: f.payheads_id || f.PayheadsID,
          formula_type: f.formula_type || f.FormulaType || 1,
          payhead_name: f.payhead_name || f.PayHeadName || '',
          payhead_alias: f.payhead_alias || f.PayHeadAlias || '',
        }))
      : [],
    slabs: Array.isArray(item.slabs)
      ? item.slabs.map((s) => ({
          id: s.id,
          amt_from: Number(s.amt_from !== undefined ? s.amt_from : s.AmtFrom || 0),
          amt_to: Number(s.amt_to !== undefined ? s.amt_to : s.AmtTo || 0),
          slab_type: Number(s.slab_type !== undefined ? s.slab_type : s.SlabType || 1),
          value: Number(s.value !== undefined ? s.value : s.Value || 0),
        }))
      : [],
  };
}

export function mapFrontendToBackend(payload) {
  const isEarning = (payload.payHeadType || '').toLowerCase().includes('earn');

  let calcCode = 'A';
  if (payload.calculationType === 'As Computed Value') calcCode = 'C';
  else if (payload.calculationType === 'Flat Rate') calcCode = 'F';
  else if (payload.calculationType === 'User Defined') calcCode = 'U';

  const categoryId = CATEGORY_MAP[payload.category] !== undefined ? CATEGORY_MAP[payload.category] : 0;

  return {
    Name: payload.name ? payload.name.trim() : '',
    Alias: payload.alias ? payload.alias.trim() : (payload.accountHead ? payload.accountHead.trim() : ''),
    AcHeadID: Number(payload.acHeadId || 0),
    IncludeInSalSlip: payload.includeInSalarySlip !== 'No',
    EffectNetSal: payload.effectNetSalary !== 'No',
    PayHeadType: isEarning ? 'E' : 'D',
    IncomeType: (payload.incomeType || '').toLowerCase() === 'variable' ? 'V' : 'F',
    CalculationType: calcCode,
    AttndanceLeaveWithPay: payload.attendanceLeaveWithPay || 'Not Applicable',
    CalculationPeriod: (payload.calculationPeriodType || '').toLowerCase() === 'days' ? 'D' : 'M',
    BasisOfCalculationPerDay: payload.basisOfCalcPerDay || 'As Per Calendar Period',
    UserDefinedDays: Number(payload.userDefinedDays || 0),
    Percentage: Number(payload.percentage || 0),
    Value: Number(payload.value || 0),
    CategoryID: categoryId,
    PaySlipDesc: payload.payslipDesc ? payload.payslipDesc.trim() : (payload.name ? payload.name.trim() : ''),
    formulas: Array.isArray(payload.formulas)
      ? payload.formulas.map((f) => ({
          payheads_id: Number(f.payheads_id),
          formula_type: Number(f.formula_type || 1),
        }))
      : [],
    slabs: Array.isArray(payload.slabs)
      ? payload.slabs.map((s) => ({
          amt_from: Number(s.amt_from || 0),
          amt_to: Number(s.amt_to || 0),
          slab_type: Number(s.slab_type || 1),
          value: Number(s.value || 0),
        }))
      : [],
  };
}

export const payHeadsApi = {
  getPayHeads: async (filters = {}) => {
    const params = {
      search: filters.search || filters.searchText || undefined,
      pay_head_type:
        filters.payHeadType && filters.payHeadType !== 'All'
          ? filters.payHeadType === 'Earning'
            ? 'E'
            : 'D'
          : undefined,
      status_filter: filters.status || filters.statusFilter || 'Active',
      page: filters.page || 1,
      page_size: filters.pageSize || 25,
    };

    const { data } = await api.get('/payroll/pay-heads/', { params });
    const rawItems = Array.isArray(data?.items) ? data.items : [];
    const items = rawItems.map(mapBackendToFrontend);

    return {
      items,
      total: data?.total || items.length,
      totalCount: data?.total_count || items.length,
      totalPages: data?.total_pages || Math.ceil((data?.total_count || items.length) / (filters.pageSize || 25)) || 1,
      page: data?.page || filters.page || 1,
      pageSize: data?.page_size || filters.pageSize || 25,
    };
  },

  getPayHeadById: async (id) => {
    const { data } = await api.get(`/payroll/pay-heads/${id}`);
    return mapBackendToFrontend(data);
  },

  getPayHeadOptions: async (excludeId = null) => {
    const params = excludeId ? { exclude_id: excludeId } : {};
    const { data } = await api.get('/payroll/pay-heads/options', { params });
    return data;
  },

  createPayHead: async (payload) => {
    const body = mapFrontendToBackend(payload);
    const { data } = await api.post('/payroll/pay-heads/', body);
    return data;
  },

  updatePayHead: async (id, payload) => {
    const body = mapFrontendToBackend(payload);
    const { data } = await api.put(`/payroll/pay-heads/${id}`, body);
    return data;
  },

  archivePayHead: async (id) => {
    const { data } = await api.post(`/payroll/pay-heads/${id}/archive`);
    return data;
  },

  deletePayHead: async (id) => {
    const { data } = await api.delete(`/payroll/pay-heads/${id}`);
    return data;
  },
};
